"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  props: ["href", "faIcon"],

  data: function data() {
    return {
      iconClass: ["fab"]
    };
  },


  mounted: function mounted() {
    this.iconClass.push("fa-" + this.faIcon);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/SocialIcon.vue
// module id = nfpk
// module chunks = 0 1